import { z } from "zod";

// POST …/bundles/room_elements/detach. bundlesForEndUser isn't used: the apartment is reloaded instead.
export const coreDetachRoomElementsResponseSchema = z.object({
    data: z.object({
        newBundleId: z.number()
    })
});

// The body of CoreAPI's own errors; others carry no devMessage
export const coreApiErrorResponseSchema = z.object({
    error: z.object({
        devMessage: z.string().nullable().optional()
    }).nullable().optional()
});
